import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { TermsOfService } from './pages/TermsOfService';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
export function AppRouter() {
  return <BrowserRouter data-id="element-11">
      <Routes data-id="element-12">
        <Route path="/" element={<App data-id="element-14" />} data-id="element-13" />
        <Route path="/terms" element={<TermsOfService data-id="element-16" />} data-id="element-15" />
        <Route path="/privacy" element={<PrivacyPolicy data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}